import React from 'react';
import { usePrevious } from '@isyc-react/core/lib';
export const useSlidesPrevious = current => {
  const changedCurrent = React.useRef(false);
  const initialCurrent = React.useRef(current);
  const previousCurrent = usePrevious(current);
  const previous = React.useMemo(() => previousCurrent !== null && previousCurrent !== void 0 ? previousCurrent : 0, [previousCurrent]);
  const firstSliding = React.useMemo(() => previousCurrent === null || previousCurrent === undefined || previousCurrent === initialCurrent.current && !changedCurrent, [previousCurrent]);
  React.useEffect(() => {
    if (current !== initialCurrent.current) changedCurrent.current = true;
  }, [current]);
  return {
    previous,
    firstSliding
  };
};